import React, { useEffect, useState } from "react";
import { getAuthorFollowerCount } from "../../services/authorFollowerCount";

export default function AuthorFollowerCount() {
  const [count, setCount] = useState(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    let pending = false;
    const load = async () => {
      if (pending || controller.signal.aborted) return;
      pending = true;
      try {
        const next = await getAuthorFollowerCount({ signal: controller.signal });
        if (!controller.signal.aborted) { setCount(next); setError(false); }
      } catch {
        if (!controller.signal.aborted) setError(true);
      } finally { pending = false; }
    };
    const refreshVisible = () => { if (document.visibilityState === "visible") load(); };
    load();
    window.addEventListener("focus", refreshVisible);
    document.addEventListener("visibilitychange", refreshVisible);
    const interval = setInterval(refreshVisible, 60000);
    return () => {
      controller.abort();
      clearInterval(interval);
      window.removeEventListener("focus", refreshVisible);
      document.removeEventListener("visibilitychange", refreshVisible);
    };
  }, [retry]);

  return <>
    <div className="text-xl sm:text-2xl font-bold text-bookish-purple" aria-live="polite"
      aria-label={error ? "Circle members count unavailable" : count === null ? "Loading circle members" : `${count} circle members`}>
      {error || count === null ? "—" : count.toLocaleString()}
    </div>
    <div className="text-xs text-bookish-purpleAccent">Circle Members</div>
    {error && <button type="button" onClick={() => setRetry((value) => value + 1)}
      className="text-xs text-bookish-purple underline" aria-label="Retry follower count">Retry</button>}
  </>;
}
